export default function registerJu (lf) {
  lf.register('jugement', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {stroke} = model.getNodeStyle()
        return h(
          'svg',
          {
            x: 20,
            y: 18,
            width: 30,
            height: 30,
            fill: stroke,
            viewBox: '0 0 1126 1024'
          },

        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h(
              'polygon',
              {
                points: pointsPath,
                fill,
                stroke,
                strokeWidth,
                strokeOpacity,
                fillOpacity
              }
            ),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        // this.menu = [
        //   {
        //     className: 'lf-menu-delete',
        //     text: 'delete',
        //     callback (node) {
        //       // const comfirm = window.confirm('你确定要删除吗？')
        //       lf.deleteNode(node.id)
        //     }
        //   },
        //   {
        //     text: 'edit',
        //     className: 'lf-menu-item',
        //     callback (node) {
        //       lf.editText(node.id)
        //     }
        //   },
        //   {
        //     text: 'copy',
        //     className: 'lf-menu-item',
        //     callback (node) {
        //       lf.cloneNode(node.id)
        //     }
        //   }
        // ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}
